module.exports = __webpack_public_path__ + "static/media/menuHomeW.10783792.png";